export default __webpack_public_path__ + "static/media/search_icon.15c72ea6.svg";